import { useLazyFetchObjectByCodeQuery } from '@redux/api'

import { FIELD_VALUE_TYPE } from '@constants'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

export const useResolveFieldPath = () => {
  const [fetchObjectByCode] = useLazyFetchObjectByCodeQuery()

  return async (pathStr: string, rootObjectCode: string): Promise<EmbeddedObject[]> => {
    if (!pathStr?.trim() || !rootObjectCode) return []

    const pathFields = pathStr.split('.')
    const pathArray: EmbeddedObject[] = []
    let currentObjectCode = rootObjectCode
    let prevValueType: FIELD_VALUE_TYPE = FIELD_VALUE_TYPE.OBJ_PK_LINK

    for (const field of pathFields) {
      let objectData

      try {
        objectData = await fetchObjectByCode(currentObjectCode).unwrap()
      } catch {
        break
      }

      const fieldDef = objectData.fields.find((f: any) => f.name === field)

      if (!fieldDef) break

      pathArray.push({
        objectCode: currentObjectCode,
        field,
        valueType: fieldDef.valueType,
        refValueType: prevValueType,
        isPk: fieldDef.isPk,
        isInternalId: fieldDef.isInternalId,
        description: fieldDef.desc ?? undefined,
        model: fieldDef.model,
      })

      prevValueType = fieldDef.valueType

      if (fieldDef.model) {
        currentObjectCode = fieldDef.model
      } else {
        break
      }
    }

    return pathArray
  }
}
